<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">
      <div class="title title--lg">Welcome to the AAOS Resident Management Portal</div>

      <div>
        Manage rosters and register residents for OITE and other programs in one convenient location.
      </div>
      <div class="bolder spacing">
        Roster Management
      </div>
      <div *ngIf="enrollmentPeriodActive">
        Add residents to the roster, maintain resident information, and enter transition information as residents near
        the end of their residency. Enrollment for the academic year will begin {{enrollmentBeginDate | date: 'MMMM d'}}.
        Please note that transitions for Post Graduate Year 5
        residents can be entered through {{transitionEndDate | date: 'MMMM d'}}.
      </div>
      <div *ngIf="!enrollmentPeriodActive">
        Add residents to the roster, maintain resident information, and enter transition information as residents near
        the end of their residency. Enrollment for the academic year will begin {{enrollmentBeginDate | date: 'MMMM d'}}.
        Please note that transitions for Post Graduate Year 5 residents can be entered through {{transitionEndDate | date: 'MMMM d'}}.
      </div>
      <div *ngIf="enrollmentPeriodActive && editPrivileges" class="btn--container">
        <button class="btn btn--solid btn--red" [disabled]="!editPrivileges" (click)="goToRoster()">
          Enrollment
        </button>
      </div>
      <div class="bolder spacing">
        AAOS Orthopaedic In-Training Examination® (OITE®)
      </div>
      <div>
        The AAOS Orthopaedic In-Training Examination (OITE) is a proctored exam administered each year to U.S.
        orthopaedic residency programs – and many international programs. The OITE is a
        comprehensive, multiple choice, computer-based examination designed to facilitate knowledge assessment in
        established principles and conventional procedures and treatment modalities in orthopaedic surgery.
        Registration for the exam is September 1 through September 30.
        <span *ngIf="oitePeriod && editPrivileges">
          Click Resident Registration to register the residents for the exam.
        </span>
      </div>
      <div class="btn--container">
        <button *ngIf="showLearnMore" cl*ngIf="showLearnMore" ass="btn btn--solid btn--red" (click)="goToRoster()">
          Learn More
        </button>
        <button *ngIf="oitePeriod && editPrivileges" [disabled]="!editPrivileges" class="btn btn--solid btn--red" (click)="goToOITE()">
          Resident Registration
        </button>
      </div>

      <div *ngIf="residentCurriculum">
        <div class="bolder spacing">
          Resident Orthopaedic Core Knowledge (ROCK)
        </div>
        <div>
            The Resident Orthopaedic Core Knowledge (ROCK) platform is the premier online learning program for orthopaedic residents. This resource provides a comprehensive learning experience for residents, powerful analytic tools for program directors, supplemental material for faculty, and more. 
            <ul>
              <li>ROCK is the only multimedia learning tool that establishes a core knowledge baseline required for orthopaedic practice.</li>
              <li>It enables program directors to evaluate their residents' progress throughout their residency training.</li>
            </ul>
            ROCK is more than a study tool – here are some of the program’s valuable benefits:
          <ul>
            <li>Discounts on selected courses, available only to programs that subscribe to ROCK.</li>
            <li>Program directors have the ability to tailor study schedules to their curriculum and incorporate preferred resources into additional assignments.</li>
            <li>Performance dashboards allow program directors to assess residents’ progress and monitor progress across ROCK, ResStudy & OITE in one interface.</li>
            <li>Resident dashboards provide insights into individual study progress and benchmarking alongside peer residents using ROCK.</li>
            <li>Enrolling faculty users to the platform so they have access to the content the residents are studying. To do this, enter your faculty users to the roster in the “Faculty” tab in the Resident Enrollment Portal.</li>
          </ul>
        </div>
        <div class="btn--container">
          <button class="btn btn--solid btn--red" [disabled]="!editPrivileges" (click)="goToFaculty()">
            Faculty
          </button>
        </div>
      </div>

      <div class="btn--container">
        <button *ngIf="showLearnMore" class="btn btn--solid btn--red" (click)="goToRoster()">
          Learn More
        </button>
        <!-- <button  *ngIf= "residentCurriculum && editPrivileges" [disabled]="!editPrivileges" class="btn btn--solid btn--red" (click)="goToRoster()">
      Register
    </button> -->
      </div>
    </div>
  </div>
</div>
